import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import LegalBradcrumeSection from "../Community/LegalBradcrumeSection";
import { Helmet } from "react-helmet";
import AllservicePlansBox from "../Deshboard/DeshBoardPlans/AllservicePlansBox";
import { useAuth } from "../../Store/AuthContext";
import { AllServicePlansData } from "../FetchAPI";
import "./ServicePlansAll.css";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";

export default function ServicePlansAll() {
  let { catid } = useParams();
  const { userID, RendomTokenfetch, userRoll } = useAuth();
  // console.log(CatNamesigle);

  const [categories, setCategories] = useState([]);
  const [services, setServices] = useState([]);
  const [subServices, setSubServices] = useState([]);

  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedService, setSelectedService] = useState("");
  const [selectedsubServices, setSelectedsubServices] = useState("");
  const [error, setError] = useState(null);

  const [Allplans, setAllplans] = useState([]);

  // console.log(Allplans);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (catid) {
      setSelectedCategory(catid);
    }
  }, [catid]);

  const FetchAllplans = useCallback(async () => {
    setAllplans([]);
    try {
      setLoading(true);
      const data = await AllServicePlansData(
        RendomTokenfetch,
        selectedCategory,
        selectedService,
        selectedsubServices,
        userRoll,
        "5",
        "0"
      );
      setAllplans(data);
    } catch (error) {
      console.error("Error fetching Plans:", error);
    } finally {
      setLoading(false);
    }
  }, [
    RendomTokenfetch,
    selectedCategory,
    selectedService,
    selectedsubServices,
    userRoll,
  ]);

  useEffect(() => {
    FetchAllplans();
  }, [FetchAllplans]);

  // Fetch categories on component mount
  useEffect(() => {
    setLoading(true);
    let fdata = new FormData();
    fdata.append("userid", userID);
    const FetchVendorcatData = async () => {
      try {
        await axios
          .post(`${WebsiteAPIurl}getallcategoryvendor`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log("API Response:", response.data);
            if (response.data.Status === "1") {
              setCategories(response.data.catdata || []);
            }
            if (response.data.Status === "0") {
              setCategories([]);
            }
          });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    FetchVendorcatData();
  }, [RendomTokenfetch, userID]);

  // Fetch services when category changes
  useEffect(() => {
    setLoading(true);
    let fdata = new FormData();
    fdata.append("userid", userID);
    fdata.append("catid", selectedCategory);
    setSelectedService("");
    setSelectedsubServices([]);
    const FetchVendorServiceData = async () => {
      try {
        await axios
          .post(`${WebsiteAPIurl}allcatservicevendor`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log("API Response:", response.data);
            if (response.data.Status === "1") {
              setServices(response.data.servicedata || []);
              setSubServices([]);
            }
            if (response.data.Status === "0") {
              setServices([]);
              setSubServices([]);
            }
          });
      } catch (err) {
        setError(err.message);
        // console.error('Error:', err.response ? err.response.data : err.message);
      } finally {
        setLoading(false);
      }
    };

    FetchVendorServiceData();
  }, [RendomTokenfetch, selectedCategory, userID]);

  // Fetch sub-services and states when service changes
  useEffect(() => {
    let fdata = new FormData();
    fdata.append("userid", userID);
    fdata.append("serviceid", selectedService);
    fdata.append("catid", selectedCategory);

    setSelectedsubServices("");
    const FetchSubServiceStateData = async () => {
      try {
        await axios
          .post(`${WebsiteAPIurl}StateAndSubservice`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log("API Response:", response.data);
            if (response.data.Status === "1") {
              setSubServices(response.data.servicedata || []);
            } else {
              setSubServices([]);
            }
          });
      } catch (err) {
        setError(err.message);
        // console.error('Error:', err.response ? err.response.data : err.message);
      } finally {
      }
    };

    FetchSubServiceStateData();
  }, [RendomTokenfetch, selectedService, selectedCategory, userID]);

  if (loading) {
    // return <APIDataFetchLoader />;
  }
  if (error) {
    return alert(error);
  }

  return (
    <>
      <Helmet>
        <title>Yourdoorstep - All Plans</title>
        <meta name="description" content={""} />
        <meta name="keywords" content={""} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <LegalBradcrumeSection
        Pagename={"All Service Plans"}
        page1={[{ name: "All Plans" }]}
      />

      <section className="job-categories section_padding_top section_padding_bottom bgc-home20">
        <div className="auto-container">
          {/* <div className="sec-title text-center">
          <h2>{ServiceCat.category}</h2>
          </div> */}
          {/* <div className="row wow fadeInUp">
   

          </div> */}

          <div className="row">
            <div className="col-lg-12">
              <div className="ls-widget">
                <div className="tabs-box">
                  <div className="widget-title pb-0 p-3 newsvendorfliderheading">
                    <p className="mb-2 filterheading">FILTER BY</p>
                  </div>
                  <div className="widget-content p-3">
                    <form className="was-validated">
                      <div className="row">
                        <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                          <label>Category</label>
                          <select
                            className="form-control"
                            value={selectedCategory}
                            onChange={(e) =>
                              setSelectedCategory(e.target.value)
                            }
                            // disabled={!!selectedCategory}
                            required
                          >
                            <option value="">Select Category</option>
                            {categories.map((val) => (
                              <option value={val.id} key={val.id}>
                                {val.category}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                          <label>Service</label>
                          <select
                            className="form-control"
                            value={selectedService}
                            onChange={(e) => setSelectedService(e.target.value)}
                            // disabled={!!selectedService}
                            required
                          >
                            <option value="">Select Service</option>
                            {services.map((value) => (
                              <option value={value.id} key={value.id}>
                                {value.title}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                          <label>Sub Service</label>
                          <select
                            className="form-control"
                            value={selectedsubServices}
                            onChange={(e) =>
                              setSelectedsubServices(e.target.value)
                            }
                          >
                            <option value="">Select Sub Service</option>
                            {subServices.map((subService) => (
                              <option value={subService.id} key={subService.id}>
                                {subService.title}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      {/* <div className="col-lg-12 col-md-12 text-center mt-3">
                                  <button className="theme-btn btn-style-three submitbtn">
                                    Submit
                                  </button>
                                </div> */}
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-4">
            {Allplans.length > 0 ? (
              Allplans.map((value, index) => (
                <AllservicePlansBox
                  key={index}
                  planid={value.id}
                  planimage={value.image}
                  title={value.title}
                  planslug={value.slug}
                  selling_price={value.selling_price}
                  price={value.price}
                  service_tag={value.feature_tag}
                />
              ))
            ) : (
              <>
                <div className="text-center fs-4">Data Not Found!</div>
              </>
            )}
          </div>
        </div>
      </section>
    </>
  );
}
